(function () {
    'use strict';

    angular
        .module('FormBuilder')
        .factory('FormElements', FormElements);

    function FormElements(lodash, $timeout) {
        return function (mem) {
            return {
                setValidationRules: setValidationRules,
                clearElementValidationRule: clearElementValidationRule,
                getValidationRule: getValidationRule,
                syncRenderedElements: syncRenderedElements,
                getRenderedElements: getRenderedElements,
                updateRenderedElements: updateRenderedElements,
                setValidationError: setValidationError,
                setValidationSummary: setValidationSummary,
                clearValidationSummary: clearValidationSummary
            };

            function setValidationError(elementIdentifier, error, dont_jump) {
                lodash.set(mem, ['validation.rules', elementIdentifier].join('.'), error);
                if (!dont_jump) {
                    gotoFirstError();
                }
            }

            function clearElementValidationRule(elementIdentifier) {
                lodash.set(mem, ['validation.rules', elementIdentifier].join('.'), []);
            }


            function setValidationSummary(rules, summary, preventScrollToError, summary_field) {
                if (!summary_field) {
                    summary_field = 'summary';
                }
                var validation_obj = {
                    rules: rules,
                };
                validation_obj[summary_field] = summary;

                lodash.set(mem, 'validation', validation_obj);

                if (!!preventScrollToError) return true;

                gotoFirstError();
            }

            function clearValidationSummary(elementIdentifier) {
                lodash.set(mem, ['validation.rules', elementIdentifier].join('.'), []);
                mem.validation.summary = null;
            }

            function setValidationRules(rules, summary, preventScrollToError, summary_field) {
                if (!summary_field) {
                    summary_field = 'summary';
                }
                var validation_obj = {
                    rules: rules,
                };
                validation_obj[summary_field] = summary;

                lodash.set(mem, 'validation', validation_obj);

                if (!!preventScrollToError) return true;

                gotoFirstError();
            }

            function gotoFirstError() {
                $timeout(function () {
                    if (mem.validation.summary) {
                        if (angular.element('.callout').length > 0) {
                            angular.element('html,body').animate({
                                scrollTop: angular.element('.callout').offset().top - 50
                            }, 500);
                        }
                    } else {
                        if (angular.element('.error').length > 0) {
                            angular.element('html,body').animate({
                                scrollTop: angular.element('.error').offset().top - 50
                            }, 500);
                        }
                    }
                });
            }

            function getValidationRule(elementIdentifier) {
                // if (elementIdentifier.indexOf('sub_candidate_education') >= 0) {
                //     console.log(mem.validation.rules);
                // }
                return lodash.get(mem.validation, ['rules', elementIdentifier].join('.'), false);
            }

            function syncRenderedElements(ref) {
                mem.renderedElements = ref;
            }

            function getRenderedElements() {
                return mem.renderedElements;
            }

            function updateRenderedElements(elementPath, data, checkRendered, fieldSpecificData) {
                var element = null;
                if (checkRendered) {
                    element = lodash.get(mem.renderedElements, elementPath, {});
                } else {
                    element = lodash.find(mem.elements, { name: elementPath });
                }


                angular.forEach(data, function (value, field) {
                    var previous = lodash.get(element, field, null);
                    if (previous === null) {
                        lodash.set(element, field, value);
                    } else {
                        if (previous instanceof Array || !(typeof previous == typeof {})) {
                            lodash.set(element, field, value);
                        } else {
                            var newValue = angular.merge(previous, value);
                            lodash.set(element, field, newValue);
                        }
                    }
                });

                if (fieldSpecificData) {
                    var enum_lists = lodash.get(fieldSpecificData, 'datasources', []);
                    var path = lodash.get(fieldSpecificData, 'path', 'options.datasource.data');
                    var element_enum = lodash.get(enum_lists, elementPath, []);
                    lodash.set(element, path, element_enum);
                    
                }


            }
        };
    }
})();